import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const ProductCollections = ({ isProductCollectionsEnabled }) => {
  const i18n = useContext(I18nContext);
  const productCollectionsText = isProductCollectionsEnabled ? i18n.getString(_TL_('Enabled')) : i18n.getString(_TL_('Not enabled'));

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Product collections') }}>
      <Text>{productCollectionsText}</Text>
    </PropertyRow>
  );
};

ProductCollections.propTypes = {
  isProductCollectionsEnabled: PropTypes.bool,
};

ProductCollections.defaultProps = {
  isProductCollectionsEnabled: false,
};
